import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography } from 'common/typography';

import { ItemTypes, VirtualizedListItem, VirtualizedSection } from './types';

export const createResultSection = (children: JSX.Element[], groupHeader: string): VirtualizedSection | null => {
  if (!children.length) {
    return null;
  }

  return {
    header: (
      <Typography.Heading6>
        <FormattedMessage id={groupHeader} />
      </Typography.Heading6>
    ),
    items: children,
  };
};

export const buildVirtualizedListItems = (sections: VirtualizedSection[]) => {
  const listItems: VirtualizedListItem[] = [];

  sections.forEach((section, idx) => {
    const listHeader = {
      type: ItemTypes.Header,
      node: section.header,
    };

    listItems.push(listHeader);

    const items = section.items.map(item => ({ type: ItemTypes.ListItem, node: item }));
    listItems.push(...items);

    // Introduce additional spacing in between sections
    const isLastElement = idx === sections.length - 1;

    if (!isLastElement) {
      const spacer = { type: ItemTypes.Spacer, node: <br /> };
      listItems.push(spacer);
    }
  });

  return listItems;
};
